import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const PredictionList = Loadable({
  loader: () => import("./PredictionList"),
  loading: Loading
})
